import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { RootState } from '../store';
import { IBreadCrumb } from '@entities/util/IBreadCrumb';

export interface IBreadcrumbsState {
  value: IBreadCrumb[] | null;
}

const initialState: IBreadcrumbsState = {
  value: null,
};

export const breadcrumbsSlice = createSlice({
  initialState,
  name: 'breadcrumbsSlice',
  reducers: {
    setBreadcrumbs: (state: any, action: PayloadAction<IBreadCrumb[]>) => {
      state.value = action.payload;
    },
  },
});

export default breadcrumbsSlice.reducer;

export const selectBreadcrumbs = (state: RootState) => state.breadcrumbs.value;

export const { setBreadcrumbs } = breadcrumbsSlice.actions;
